import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { ENewFilterRangeDesktop } from './static-props'
import { ariaLabel } from '../../utils/form-utilities'

const FrameSizeMin = withFilterContext(FilterName.min_frame_size_cm, SearchFiltersDropdown, {
    title: ENewFilterRangeDesktop.MIN,
    ariaLabel: ariaLabel.frameSize.min,
})
const FrameSizeMax = withFilterContext(FilterName.max_frame_size_cm, SearchFiltersDropdown, {
    title: ENewFilterRangeDesktop.MAX,
    ariaLabel: ariaLabel.frameSize.max,
})
export const FrameSizeMinFacetAndFilter = withFacetContext(FacetName.frame_size_cm, FrameSizeMin)

export const FrameSizeMaxFacetAndFilter = withFacetContext(FacetName.frame_size_cm, FrameSizeMax)
